import React from 'react'
import { number } from 'prop-types'
import { Rating } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function Stats({
  userRating, reviewCount = 0,
}) {
  const roundedUserRating = Math.round(userRating)

  if (!reviewCount) {
    return null
  }

  return (
    <div className="cgt-user-card-new__stats">
      <Rating
        className="cgt-user-card-new__rating"
        id="rating"
        initialValue={roundedUserRating}
        isCheckboxHidden
        isDisabled
        isReadOnly
        size="tiny"
      />
      <span className="cgt-legacy-text-tiny cgt-legacy-color-typography-disabled">{reviewCount}</span>
    </div>
  )
}

Stats.propTypes = {
  userRating: number.isRequired,
  reviewCount: number,
}

export default Stats
